module.exports = __webpack_public_path__ + "static/media/cover-unavaliable-2.017b9779.png";